<script setup lang="ts">
const item = ref<HTMLDivElement>();
const enableDOM = ref(true);
const targetIsVisible = useElementVisibility(item);

const stopWatch = watch(item, () => {
  if (targetIsVisible.value && !enableDOM.value) {
    enableDOM.value = true;
    stopWatch();
  }
});
</script>

<template>
  <div
    class="media-slider-item"
    ref="item"
  >
    <slot v-if="enableDOM"></slot>
  </div>
</template>

<style scoped lang="postcss">
.media-slider-item {
  @apply block snap-start;
}
</style>
